<template>
  <ContentFrame
    :themeColor="computedTopicColor"
    :title="computedTitle"
  >
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('history.t1.title')"
      :textArray="[$t('history.t1.p0'), $t('history.t1.p1'), $t('history.t1.p2')]"
    />
    <ContentImageTile
      :themeColor="computedTopicColor"
      imageSource="/img/hans-lebrecht/02.jpg"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('history.t2.title')"
      :textArray="[$t('history.t2.p0'), $t('history.t2.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('history.t3.title')"
      :textArray="[$t('history.t3.p0'), $t('history.t3.p1')]"
    />
    <ContentTile
      :themeColor="computedTopicColor"
      :title="$t('history.t4.title')"
      :textArray="[$t('history.t4.p0'), $t('history.t4.p1'), $t('history.t4.p2')]"
      :downloadText="$t('history.t4.download')"
      downloadFileName="Hans-Lebrecht-Schule_Stolpersteine.pdf"
    >
      <v-col
          slot="content"
          v-if="emailRequestAddress"
          cols="12"
          class="py-2"
        >
          <ContactChip
            icon="mdi-email"
            :value="emailRequestAddress"
            :href="'mailto:' + emailRequestAddress + '?subject=' + emailRequestSubject"
          />
        </v-col>
    </ContentTile>
    <ContentGalleryTile
      v-if="photos.length > 0"
      :themeColor="computedTopicColor"
      :title="$t('history.gallery.title')"
      :photos="photos"
    />
  </ContentFrame>
</template>

<script>
import { mapGetters } from 'vuex'
import ContentTile from '@/views/components/ContentTile.vue'
import ContentImageTile from '@/views/components/ContentImageTile.vue'
import ContentGalleryTile from '@/views/components/ContentGalleryTile.vue'
import ContentFrame from '@/views/components/ContentFrame.vue'
import ContactChip from '@/views/components/ContactChip.vue'

export default {
  name: 'History',
  components: {
    ContentTile,
    ContentImageTile,
    ContentGalleryTile,
    ContentFrame,
    ContactChip
  },
  data () {
    return {
      emailRequestAddress: 'info@hans-lebrecht-schule.de',
      emailRequestSubject: 'Buch Stolpersteine für Familie Lebrecht',
      photos: [
        {
          src: '/img/hans-lebrecht/01.jpg',
          description: 'Der junge Hans Lebrecht in Ulm, 1930.'
        },
        {
          src: '/img/hans-lebrecht/02.jpg',
          description: 'Die Lebrecht-Brüder, 1936: l.oben Heinrich, l. unten Walter, r. unten Curt, r. oben Hans. (Foto: Archiv des Dokumentationszentrums Oberer Kuhberg Ulm)'
        },
        {
          src: '/img/hans-lebrecht/03.jpg',
          description: 'Das letzte Familienfoto in Ulm, 1936: Walter, Curt, Heinrich, Hans, Rosa und Wilhelm Lebrecht. (Foto: Archiv des Dokumentationszentrums Oberer Kuhberg Ulm)'
        },
        {
          src: '/img/hans-lebrecht/04.jpg',
          description: 'Der letzte Besuch in Ulm, 2004: Esther Bejarano, Ruth Bar-Hay, Hans Lebrecht, Ex-OB Ivo Gönner, Margalith Pozniak. (Foto: Archiv des Dokumentationszentrums Oberer Kuhberg Ulm)'
        },
        {
          src: '/img/hans-lebrecht/05.jpg',
          description: 'Windfahne. Das Lebrecht-Quartett: Otto Wiegandt, Else Lang, Eugen Roth, Wilhelm Lebrecht. (Foto: Armin Buhl)'
        },
        {
          src: '/img/hans-lebrecht/06.jpg',
          description: 'Die Fahne auf dem Dach des Hauses der Familie in Contulmo, Chile. (Foto: Manuel Lebrecht)'
        },
        {
          src: '/img/hans-lebrecht/07.jpg',
          description: 'Nachbildung der Windfahne auf Dach der ehem. Lebrecht-Villa, heute Tagesklinik der Kinder- und Jugendpsychiatrie des Universitätsklinikums Ulm. (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/01.jpg',
          description: 'Niederlegung der Rosen am Stolperstein von Karl Rueff. (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/02.jpg',
          description: 'Künstler Gunter Demnig bei der Verlegung. (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/03.jpg',
          description: 'Stolpersteine für die Familie Lebrecht. (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/04.jpg',
          description: 'Stolpersteine bei der Skulptur "Dazugehören". (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/05.jpg',
          description: 'Niederlegung der Rosen am Stolperstein von Familie Weglein. (Foto: Armin Buhl)'
        },
        {
          src: '/img/stolpersteine/06.jpg',
          description: 'Niederlegung der Rosen am Stolperstein von Jonathan Stark. (Foto: Armin Buhl)'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'menuData'
    ]),
    computedTopicColor () {
      return this.menuData.history.color
    },
    computedTitle () {
      return this.menuData.history.title
    }
  }
}
</script>
